"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterKeywordGroupState = void 0;
var SfilterKey_1 = require("@/pages/common/states/sfilter/SfilterKey");
exports.defaultSfilterKeywordGroupState = {
    key: SfilterKey_1.SfilterKey.KEYWORD,
    nameEmpty: 'Search by Keyword',
    nameNoResult: 'No result? Maybe a typo?',
    namePlaceholder: 'eg. Kowloon Station',
    opened: true,
    isSuggesting: false,
    suggestions: null,
    suggestionsSelecting: -1,
    name: 'Keyword',
    text: '',
};
